import { Sidebar } from './Sidebar'
import type WebModel from '../models/WebModel'
import { DEFAULT_REFRESH_INTERVAL } from '../constants'
import { hasOutstream } from '../outstream/hasOutstream'
import { hasNative } from '../native/hasNative'
import { isNative } from '../prebidFacade/BidderSettings'
import { AdType } from '../enums/AdType'

@hasOutstream
@hasNative
export class SidebarBtf extends Sidebar {
  slotName = 'sticky_sidebar'

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)
    this.adUnitId = 'sidebar_btf'
    this.refreshTime = DEFAULT_REFRESH_INTERVAL
    this.lazy = true
  }

  sizeContainers() {
    super.sizeContainers()
    const placeholder = document.getElementById(
      `${this.adUnitId}_placeholder`
    ) as HTMLElement
    if (!placeholder) {
      return
    }
    const MEDIAVINE_BRANDING_HEIGHT = 15
    let adHeight = Number(this.height) + MEDIAVINE_BRANDING_HEIGHT
    if (this.adType === AdType.prebidNative) {
      adHeight = 600 + MEDIAVINE_BRANDING_HEIGHT
    }
    placeholder.style.height = `${adHeight}px`
  }
}
